'use client'
import {
  ContentfulMedia_default
} from "./chunk-QX2PWGVG.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/button/ContentfulButton.tsx
import { Button } from "@wbk/ui";
import { Link } from "@wbk/config";
import { useDeviceDetect } from "@wbk/hooks";
import { scrollIntoElementId } from "@wbk/utils";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ContentfulButton = (_a) => {
  var _b = _a, { link, children, hideText } = _b, props = __objRest(_b, ["link", "children", "hideText"]);
  var _a2, _b2, _c, _d, _e;
  const { isWebView } = useDeviceDetect();
  const noLink = !link.href || link.href === "#";
  const linkIsSectionId = link.href.startsWith("#") && link.href.length > 1;
  const deepLinked = isWebView && !!link.deeplinkHref;
  return /* @__PURE__ */ jsx(
    Button,
    __spreadProps(__spreadValues({
      as: noLink || deepLinked || linkIsSectionId ? "button" : Link,
      href: deepLinked ? void 0 : link.href,
      shape: ((_a2 = link.image) == null ? void 0 : _a2.url) ? "text" : link.shape,
      theme: ((_b2 = link.image) == null ? void 0 : _b2.url) ? "white" : link.theme,
      target: link.isExternal ? "_blank" : void 0,
      rel: link.isExternal ? "noopener noreferrer" : void 0,
      rounded: true,
      onClick: () => {
        var _a3;
        if (deepLinked) {
          (_a3 = window.ReactNativeWebView) == null ? void 0 : _a3.postMessage(
            JSON.stringify({
              eventName: "VIEW_CHAT",
              data: {
                chat_deeplink: link.deeplinkHref
              }
            })
          );
        } else if (linkIsSectionId) {
          scrollIntoElementId(link.href.slice(1));
        }
      },
      "aria-label": link.label || ""
    }, props), {
      children: ((_c = link.image) == null ? void 0 : _c.url) ? /* @__PURE__ */ jsx(ContentfulMedia_default, { media: link.image, fit: "pad", format: null }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        ((_d = link.icon) == null ? void 0 : _d.url) && link.iconPosition === "left" && /* @__PURE__ */ jsx(ContentfulMedia_default, { className: "shrink-0", media: link.icon, fit: "pad" }),
        !hideText && link.label,
        children,
        ((_e = link.icon) == null ? void 0 : _e.url) && link.iconPosition === "right" && /* @__PURE__ */ jsx(ContentfulMedia_default, { className: "shrink-0", media: link.icon, fit: "pad" })
      ] })
    })
  );
};
var ContentfulButton_default = ContentfulButton;

export {
  ContentfulButton_default
};
//# sourceMappingURL=chunk-A5EHVVY6.mjs.map